import moment from 'moment-timezone';

const TIMEZONE_MAP = {
  USA: 'America/Chicago',
  INDIA: 'Asia/Kolkata'
};

const filterValidEvents = (events, countryCode, banner) => {
  if(!events){
    return null;
  }

  const timezone = TIMEZONE_MAP[countryCode.toUpperCase()];
  const currentTime = moment().tz(timezone);

  return events?.filter(event => {
    const eventStartTime = banner 
    ? moment.tz(`${event.concert_date?.split('T')[0]} ${event.start_time}`, 'YYYY-MM-DD hh:mm A', timezone) 
    : moment.tz(`${event.date?.split('T')[0]} ${event.startTime}`, 'YYYY-MM-DD hh:mm A', timezone);
    
    if (!eventStartTime.isValid()) return false;
    
    const timeDiff = eventStartTime.diff(currentTime, 'minutes');
    return timeDiff >= 150;
  });
}

const filterUpcomingValidEvents = (events, countryCode) => {
  if(!events){
    return null;
  }
  const timezone = TIMEZONE_MAP[countryCode.toUpperCase()];
  const currentTime = moment().tz(timezone);

  return events?.filter(event => {
    return event?.venues?.some(venue => {
      return venue?.eventDates?.some(eventDate => {
        const eventStartTime = moment.tz(`${eventDate.date?.split('T')[0]} ${eventDate.startTime}`, 'YYYY-MM-DD hh:mm A', timezone)

        if (!eventStartTime.isValid()) return false;

        const timeDiff = eventStartTime.diff(currentTime, 'minutes');
        // Only show events that are at least 2:30 hours away
        return timeDiff >= 150; 
      });
    });
  });
};

export const CountryTimeUtil = {
  filterValidEvents,
  filterUpcomingValidEvents
};

